import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=a6d000e8&"
import script from "./pie.vue?vue&type=script&lang=js&"
export * from "./pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6d000e8')) {
      api.createRecord('a6d000e8', component.options)
    } else {
      api.reload('a6d000e8', component.options)
    }
    module.hot.accept("./pie.vue?vue&type=template&id=a6d000e8&", function () {
      api.rerender('a6d000e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/pie.vue"
export default component.exports